var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.0835 18.3332H3.33349M3.33349 18.3332V11.1448C3.33349 9.94468 4.04869 8.86006 5.15174 8.38732L9.16683 6.66657M3.33349 18.3332H6.25016M9.16683 6.66657V2.29883H15.0151C15.5396 2.29883 16.0431 2.50488 16.4171 2.87258L17.1355 3.57878C17.518 3.95479 17.7334 4.46867 17.7334 5.00503V18.3332L14.1668 18.3332M9.16683 6.66657V9.16657M9.16683 18.3332H6.25016M9.16683 18.3332V14.1666M9.16683 18.3332H14.1668M6.25016 18.3332V14.1666H9.16683M9.16683 14.1666V9.16657M9.16683 9.16657H11.1668C12.8237 9.16657 14.1668 10.5097 14.1668 12.1666V18.3332",
    stroke: "#025F4C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.dd80e78d2387d8975d640d331ed05bce.svg";
export { ForwardRef as ReactComponent };